<template>
  <div class="wallets-page" v-loading="!isReady">
    <el-select v-if="wallets.length > 0" v-model="selectedWallet" slot="prepend" class="input-select">
      <el-option v-for="wallet in wallets" :key="wallet.id" :value="wallet.id.match(/(\S*)\$/)[1]">
        <router-link class="card" :to="'/dashboard/wallets-page/' + wallet.id">
          <div class="info-container" v-if="wallet.name">
            <div class="label">
              {{ wallet.name.match(/(\S*)#/)[1] }}
            </div>
            <div class="asset">
              <i class="el-icon-s-cooperation"></i>{{ wallet.amount }}
            </div>
          </div>
        </router-link>
      </el-option>
    </el-select>
    <el-col :span="20">
      <div class="main">
        <router-view />
        <el-card v-if="wallets.length === 0" class="no-assets">
          No assets

          <div>
            You can view your wallet information here when you have currency.
          </div>
        </el-card>
      </div>
    </el-col>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'wallets-page',

  data() {
    return {
      isReady: false,
      selectedWallet: ''
    }
  },

  computed: {
    ...mapGetters({
      wallets: 'wallets'
    })
  },

  watch: {
    $route(to) {
      // If moved from 'wallet' to 'wallets-page' (i.e. no wallet opens),
      // open the default one.
      if (to.name === 'wallets-page') {
        this.openDefaultWallet()
      }

      this.selectedWallet = to.params.walletId.match(/(\S*)\$/)[1]
      this.$forceUpdate()
    }
  },

  mounted() {
    // If moved from other pages to 'wallets-page', open the default one.
    this.openDefaultWallet()
  },

  created() {
    this.getAllAccountAssetsTransactions().finally(() => {
      this.isReady = true
      this.openDefaultWallet()
    })
  },

  methods: {
    ...mapActions(['getAllAccountAssetsTransactions']),
    openDefaultWallet() {
      if (this.wallets[0]) {
        this.$router.push({
          name: 'wallet',
          params: { walletId: this.wallets[0].id }
        })
      }
    }
  }
}
</script>

<style scoped>
.el-select {
  margin: 64px 16px 16px;
  display: block;
  max-width: 500px;
}
.el-select-dropdown__item {
  height: 96px;
}
.no-assets {
  margin: 5rem 0rem 5rem 12rem;
}
.sidemenu {
  border-right: 1px solid #f0f0f0;
  min-height: 100vh;
}
.card {
  display: flex;
  width: 100%;
  font-size: 14px;
  text-decoration: none;
  align-items: center;
  padding: 15px 20px;
}
.card.router-link-active {
  background: #f39800;
  padding-bottom: 13px;
}
.info-container {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.label {
  color: rgba(0, 0, 0, 0.87);
  font-size: 1.25rem;
  margin-bottom: 0.25rem;
}
.card.router-link-active > .info-container > .label {
  font-weight: 600;
  color: #fff;
}
.card.router-link-active > .info-container > .asset {
  color: #fff;
  font-weight: 600;
}
.asset {
  color: rgba(0, 0, 0, 0.6);
}
</style>
